// extracted by mini-css-extract-plugin
export default {"FeatureScreen":"FeatureScreen_FeatureScreen__4aq5q","cancelIcon":"FeatureScreen_cancelIcon__t4Kp6"};